export const DEFAULT = 'default';
export const CSV = 'CSV';
export const JIRA_SOFTWARE = 'jiraSoftware';
export const JIRA_BUSINESS = 'jiraBusiness';
export const TRELLO = 'Trello';
export const SHEETS = 'Sheets';
export const EXCEL = 'Excel';
export const MONDAY = 'monday';
export const ASANA = 'Asana';
export const CLICK_UP = 'ClickUp';
export const AIRTABLE = 'Airtable';
export const SMART_SHEET = 'Smartsheet';
export const GITHUB = 'GitHub';
export const GITLAB = 'GitLab';
export const LINEAR = 'Linear';
export const AZURE_DEVOPS = 'Azure Devops';
export const NOTION = 'Notion';
export const WRIKE = 'Wrike';
export const JETBRAINS_YOUTRACK = 'Jetbrains YouTrack';

export const JIRA_DISPLAY_NAME = 'Jira';
export const TRELLO_DISPLAY_NAME = 'Trello';
export const GOOGLE_SHEETS_DISPLAY_NAME = 'Sheets';
export const EXCEL_DISPLAY_NAME = 'Excel';
export const MONDAY_DISPLAY_NAME = 'monday';
export const ASANA_DISPLAY_NAME = 'Asana';
export const CLICK_UP_DISPLAY_NAME = 'ClickUp';
export const AIRTABLE_DISPLAY_NAME = 'Airtable';
export const SMART_SHEET_DISPLAY_NAME = 'Smartsheet';
export const GITHUB_DISPLAY_NAME = 'GitHub';
export const LINEAR_DISPLAY_NAME = 'Linear';
export const GITLAB_DISPLAY_NAME = 'GitLab';
export const AZURE_DEVOPS_DISPLAY_NAME = 'Azure DevOps';
export const NOTION_DISPLAY_NAME = 'Notion';
export const WRIKE_DISPLAY_NAME = 'Wrike';
export const JETBRAINS_YOUTRACK_DISPLAY_NAME = 'Jetbrains YouTrack';

export const SITE_ADMIN = 'SITE_ADMIN';
export const CREATE_PROJECT = 'CREATE_PROJECT';

export type SupportedThirdParty =
	| typeof TRELLO
	| typeof ASANA
	| typeof MONDAY
	| typeof JIRA_SOFTWARE
	| typeof CLICK_UP
	| typeof JIRA_BUSINESS;

export type JiraThirdParty = typeof JIRA_SOFTWARE | typeof JIRA_BUSINESS;

export const SupportedThirdParties = new Set([TRELLO, ASANA, MONDAY, JIRA_SOFTWARE, CLICK_UP]);

export type ImportType = typeof DEFAULT | typeof CSV | SupportedThirdParty | string;

export const supportedImportTypesFromQueryParam = new Set([DEFAULT, TRELLO]);

export type ToolNameKey =
	| typeof TRELLO
	| typeof JIRA_SOFTWARE
	| typeof SHEETS
	| typeof EXCEL
	| typeof MONDAY
	| typeof ASANA
	| typeof CLICK_UP
	| typeof AIRTABLE
	| typeof SMART_SHEET
	| typeof GITHUB
	| typeof LINEAR
	| typeof JIRA_BUSINESS;

export const SourceItemKeys = new Set([
	CSV,
	TRELLO,
	JIRA_SOFTWARE,
	SHEETS,
	EXCEL,
	MONDAY,
	ASANA,
	CLICK_UP,
	AIRTABLE,
	SMART_SHEET,
	GITHUB,
	LINEAR,
	GITLAB,
	AZURE_DEVOPS,
	NOTION,
	WRIKE,
	JETBRAINS_YOUTRACK,
]);

export type UserAccess = typeof SITE_ADMIN | typeof CREATE_PROJECT;
